const state = {
  detail: {},
  data: {},
  categorys: [],
};
const mutations = {
  SET_DETAIL: (state, payload) => {
    state.data = payload;
  },
  SET_CATEGORYS: (state, payload = []) => {
    state.categorys = payload;
  },
};
const actions = {};
const getters = {
  //detail: state => state.detail
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// src/store/modules/detail.js